import { ErrorLogComponent } from '@cian/error-log-component';
import * as React from 'react';
import { Provider } from 'react-redux';
import { uaToDeviceType } from '@cian/ui-kit/utils';
import { UiKitRoot } from '@cian/ui-kit';

import { PageContainer } from '../PageContainer';
import { TReduxStore } from '../../types/redux';
import { IApplicationContext as IAppContext } from '../../types/ICustomContextParams';
import { ApplicationContext } from '../../utils/applicationContext';

export interface IApplicationProps {
  reduxStore: TReduxStore;
  context: IAppContext;
}

export const Application: React.FC<React.PropsWithChildren<IApplicationProps>> = props => {
  const { reduxStore, context } = props;
  const {
    logger,
    custom: { userAgent },
  } = context;

  return (
    <ApplicationContext.Provider value={context}>
      <ErrorLogComponent logger={logger}>
        <UiKitRoot deviceType={uaToDeviceType(userAgent)}>
          <Provider store={reduxStore}>
            <PageContainer />
          </Provider>
        </UiKitRoot>
      </ErrorLogComponent>
    </ApplicationContext.Provider>
  );
};
